import React, { useEffect, useState, useRef } from "react";
import Header from "./partials/header/Header";
import Footer from "./partials/footer/Footer";
import { Outlet, useParams } from "react-router-dom";
import CookieConsent from "react-cookie-consent";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { setContent } from "./stores/mainSlice";
import Spinner from "react-bootstrap/Spinner";
import { setLang } from "./stores/mainSlice";
import { getContent } from "./utils/main";
import * as Icon from "react-bootstrap-icons";

const App = () => {
  const dispatch = useDispatch();
  // Lang
  const lang = useSelector((state) => state.mainSlice.lang);
  const content = useSelector((state) => state.mainSlice.content);

  const goTop = useRef(null);
  const toggleClass = "show";

  useEffect(() => {
    window.addEventListener("scroll", () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 200) {
        if (goTop.current !== null) goTop.current.classList.add(toggleClass);
      } else {
        if (goTop.current !== null) goTop.current.classList.remove(toggleClass);
      }
    });
  }, []);

  useEffect(() => {
    if (localStorage.getItem("lang") === null) {
      localStorage.setItem("lang", "tm");
    } else {
      dispatch(setLang(localStorage.getItem("lang")));
    }
  }, [dispatch]);
  const [isLoading, setIsLoading] = useState(true);
  const [contentError, setContentError] = useState(null);
  const errorButton =
    lang === "en"
      ? "Reload"
      : lang === "ru"
      ? "Перезагрузить"
      : "Gaýtadan ýükläň";
  const params = useParams();
  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/v1/main/content/`)
      .then((res) => {
        dispatch(setContent(res.data));
      })
      .then(() => {}).catch(() => {
        setContentError(
          lang === "en"
            ? "Something went wrong!"
            : lang === "ru"
            ? "Что-то пошло не так!"
            : "Ýalňyşlyk ýüze çykdy!"
        );
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [params, dispatch]);
  return isLoading === true ? (
    <div id="loader">
      <Spinner animation="border" role="status" style={{ color: "#198754" }}>
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    </div>
  ) : contentError !== null ? (
    <div className="d-flex flex-column align-items-center justify-content-center h-100 something-went-wrong">
      <img
        src={require("./assets/images/2d-logo.png")}
        alt="Logo"
        style={{ width: "150px" }}
      />
      <br />
      <h4>{contentError}</h4>
      <br />
      <a href={process.env.REACT_APP_API_URL} className="black-btn">
        <Icon.ArrowClockwise /> {errorButton}
      </a>
    </div>
  ) : (
    <main>
      <Header />
      <Outlet />
      <Footer />
      <div
        className="go-to-top "
        ref={goTop}
        onClick={() => {
          window.scrollTo(0, 0);
        }}
      >
        <Icon.ChevronUp />
      </div>
      <div className="d-none">
        <CookieConsent
          location="bottom"
          buttonText="OK"
          cookieName="ashgabat_session"
          style={{ background: "#2B373B" }}
          buttonStyle={{
            color: "#4e503b",
            fontSize: "13px",
            borderRadius: "5px",
          }}
          expires={150}
        >
          {getContent(
            content,
            "Our site uses a technical data collection service to provide you with the best possible service. By continuing to use our site, you automatically agree to use this service.",
            lang
          )}{" "}
        </CookieConsent>
      </div>
    </main>
  );
};

export default App;
